export { default } from '@mui/system/useMediaQuery';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/useMediaQuery/index.js
// module id = 533
// module chunks = 25